import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Fab, Grid, Typography, useMediaQuery, } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
// import { faqs } from "./acceleratedCashbackData";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ctaImage from '../../pages/mystery-box/images/bg-top.png';
import Mystery from '../../pages/mystery-box/images/image.png';
import Heading from '../../pages/mystery-box/images/top-heading.png';
import Mbheading from '../../pages/mystery-box/images/mbheading.png';
import UnlockHeading from '../../pages/mystery-box/images/unlock-heading.png'
import Lock from '../../pages/mystery-box/images/lock.png';
import RegisterButton from '../../pages/mystery-box/images/cta1.png';
import StickyRegisterButton from '../../pages/mystery-box/images/sticky-reg.png';
import Unlock from '../../pages/mystery-box/images/unlock.png';
import Openimage from '../../pages/mystery-box/images/open.png';
import Bg from '../../pages/mystery-box/images/state-bg.png';
import ReactHtmlParser from 'html-react-parser';
import RevealButton from '../../pages/mystery-box/images/reaveal.png';
import { useNavigate } from 'react-router-dom';
import RegisterDrawer from './component/registerDrawer';
import staticBg from './images/bgGif.gif'
import ErrorAlert from './component/errorAlert';
import dor from './images/dor.png'
import newsec from './images/newsec.png'
import newsec2 from './images/newsec2.png'
import newsec24 from './images/newsec24.png'
import subtract from './images/subtract.png'
import Message from './images/message-question.png'
import Explore from './images/explorecta.png'
import VStepper from './component/Stepper';
import Scroll from './images/scroll-down.gif'
import STL from './images/stl.png';
import MysteryBox from './images/Myster box.json';
import Lottie from "lottie-react";
import Remember from "./images/step screen 02.json";
import RegisterButtons from "./images/register now button.json";
import Pallerel from "./images/sand animation.json";
import MysteryLogo from "./images/Mystery logo.json";
import Faq from "./component/faq";

const deals = [
  {
    name: "Reliance Digital",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/reliance-digital.png",
    link: 'cashkaro://stores/reliancedigital-coupons',
    cashback:'Upto 3% Cashback',
    // bonus:'Flat ₹210 Bonus',
  },
  {
    name: "Times Prime",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/Times.png",
    link: 'cashkaro://stores/times-prime-coupons',
    cashback:'Flat ₹400 Cashback',
    // bonus:'Flat ₹20 Bonus',
  },
  // {
  //   name: "SSBeauty",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/ss-beauty.png",
  //   link: 'cashkaro://stores/ssbeauty-coupons-excl-offr-mar26',
  //   cashback:'Flat 18% Cashback',
  //   bonus:'Flat ₹140 Bonus',
  // },
  {
    name: "Agoda",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/agoda.png",
    link: 'cashkaro://stores/agoda',
    cashback:'Flat 7% Cashback',
    // bonus:'Flat ₹105 Bonus',
  },
  // {
  //   name: "Croma",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/croma.png",
  //   link: 'cashkaro://stores/croma-excl-offr-apr26',
  //   cashback:'Upto 3% Cashback',
  //   bonus:'Flat ₹ 90 Bonus',
  // },
  {
    name: "Muscleblaze",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/muscle-blaze.png",
    link: 'cashkaro://stores/muscleblaze-coupon-codes',
    cashback:'Flat 8% Cashback',
    // bonus:'Flat ₹80 Bonus',
  },
  {
    name: "Shyaway",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/shyway.png",
    link: 'cashkaro://stores/shyaway-coupons',
    cashback:'Flat 25% Cashback',
    // bonus:'Flat ₹75 Bonus',

  },
  {
    name: "Jivisa",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/jivisa.png",
    link: 'cashkaro://stores/jivisa-offers',
    cashback:'Flat 65% Cashback',
    // bonus:'Flat ₹65 Bonus',

  },
  {
    name: "Koparo Clean",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/koparo.png",
    link: 'cashkaro://stores/koparoclean-coupons',
    cashback:'Flat 40% Cashback',
    // bonus:'Flat ₹60 Bonus',

  },
  {
    name: "Hyugalife",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/hyugalife.png",
    link: 'cashkaro://stores/hyugalife-coupons',
    cashback:'Upto 9% Cashback',
    // bonus:'Flat ₹55 Bonus',

  },
  // {
  //   name: "Nykaa",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/nykaa.png",
  //   link: 'cashkaro://stores/nykaa-excl-offr-apr26',
  //   cashback:'Upto 4% Cashback',
  //   bonus:'Flat ₹50 Bonus',

  // },
  // {
  //   name: "Expedia",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/expedia.png",
  //   link: 'cashkaro://stores/expedia-flightbookings-excl-offr-mar26',
  //   cashback:'Upto 3% Cashback',
  //   bonus:'Flat ₹50 Bonus',

  // },
  {
    name: "Booking.com",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/booking.png",
    link: 'cashkaro://stores/booking',
    cashback:'Flat 3.5% Cashback',
    // bonus:'Flat ₹200 Bonus',

  },
  // {
  //   name: "Bewakoof.com",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/bewakoof.png",
  //   link: 'cashkaro://stores/bewakoof-excl-offr-mar26',
  //   cashback:'Flat 18% Cashback',
  //   bonus:'Flat ₹45 Bonus',

  // },
  
  {
    name: "Shopsy",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/Shopsy.png",
    link: 'cashkaro://stores/shopsy-coupons',
    cashback:'Upto 9% Cashback',
    // bonus:'Flat ₹10 Bonus',

  },
  {
    name: "Sanfe",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/sanfe.png",
    link: 'cashkaro://stores/sanfe-offers',
    cashback:'Flat 18% Cashback',
    // bonus:'Flat ₹20 Bonus',

  },
  // {
  //   name: "OTT Play",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/ott.png",
  //   link: 'cashkaro://stores/ottplay-super-play-coupons-excl-offr-mar26',
  //   cashback:'Flat ₹149 Cashback',
  //   bonus:'Flat ₹40 Bonus',

  // },
  {
    name: "Libas",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/libas.png",
    link: 'cashkaro://stores/libas-coupons',
    cashback:'Flat 7% Cashback',
    // bonus:'Flat ₹40 Bonus',

  },
  // {
  //   name: "Nutrabay",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/nutrabay.png",
  //   link: 'cashkaro://stores/nutrabay-coupon-codes-excl-offr-apr26',
  //   cashback:'Upto 10% Cashback',
  //   bonus:'Flat ₹35 Bonus',

  // },
  {
    name: "Nutriburst",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/nutri.png",
    link: 'cashkaro://stores/nutriburst-india-coupons',
    cashback:'Flat 45% Cashback',
    // bonus:'Flat ₹20 Bonus',

  },
  // {
  //   name: "Nippon Paint",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/nippon.png",
  //   link: 'cashkaro://stores/nippon-paint-coupons-excl-offr-apr26',
  //   cashback:'Flat 70% Cashback',
  //   bonus:'Flat ₹40 Bonus',

  // },
  // {
  //   name: "Clove Oral Care",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/cclove.png",
  //   link: 'cashkaro://stores/clove-oral-care-coupons-excl-offr-mar26',
  //   cashback:'Upto 75% Cashback',
  //   bonus:'Flat ₹30 Bonus',

  // },
  // {
  //   name: "Bajaj Prime",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/prime.png",
  //   link: 'cashkaro://stores/bajaj-prime-coupons-excl-offr-mar26',
  //   cashback:'Flat ₹625 Cashback',
  //   bonus:'Flat ₹30 Bonus',

  // },
  {
    name: "Zandu Care",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/zanduu.png",
    link: 'cashkaro://stores/zanducare-coupons',
    cashback:'Flat 18% Cashback',
    // bonus:'Flat ₹30 Bonus',

  },
  {
    name: "The Derma Co",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/derma-co.png",
    link: 'cashkaro://stores/thedermaco-coupons',
    cashback:'Upto 20% Cashback',
    // bonus:'Flat ₹25 Bonus',

  },
  {
    name: "Cleevo",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/cleevoo.png",
    link: 'cashkaro://stores/cleevo-offers',
    cashback:'Flat 30% Cashback',
    // bonus:'Flat ₹25 Bonus',

  },
  {
    name: "Bookscape",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/bookscape.png",
    link: 'cashkaro://stores/bookscape-coupons',
    cashback:'Flat 25% Cashback',
    // bonus:'Flat ₹50 Bonus',

  },
  {
    name: "MamaEarth",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/mamaearth.png",
    link: 'cashkaro://stores/mama-earth-coupons',
    cashback:'Upto 30% Cashback',
    // bonus:'Flat ₹20 Bonus',

  },
  {
    name: "mCaffeine",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/m-caffine.png",
    cashback:'Flat 15% Cashback',
    // bonus:'Flat ₹20 Bonus',

  },
  {
    name: "Oppo",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/oppo.png",
    link: 'cashkaro://stores/oppo-coupons',
    cashback:'Upto 3% Cashback',
    // bonus:'Flat ₹20 Bonus',

  },
  {
    name: "Foxtale",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/foxtale.png",
    link: 'cashkaro://stores/foxtale-coupons',
    cashback:'Flat 15% Cashback',
    // bonus:'Flat ₹20 Bonus',

  },
  {
    name: "Dot and Key",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/dot-and-key.png",
    link: 'cashkaro://stores/dotandkey-coupons',
    cashback:'Upto 12% Cashback',
    // bonus:'Flat ₹20 Bonus',

  },
  {
    name: "Clovia",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/clovia.png",
    link: 'cashkaro://stores/clovia-coupons',
    cashback:'Flat 12% Cashback',
    // bonus:'Flat ₹20 Bonus',

  },
  {
    name: "Hyphen",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/hyphen.png",
    link: 'cashkaro://stores/hyphen-coupon-codes',
    cashback:'Flat 12% Cashback'       ,
    // bonus:'Flat ₹20 Bonus',

  },
  {
    name: "BoAt",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/boat.png",
    link: 'cashkaro://stores/boat-coupon',
    cashback:'Flat 5% Cashback',
    // bonus:'Flat ₹20 Bonus',

  },
  {
    name: "BeBodywise",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/bebody.png",
    link: 'cashkaro://stores/bebodywise-coupons',
    cashback:'Flat 20% Cashback',
    // bonus:'Flat ₹50 Bonus',

  },
  // {
  //   name: "Decathlon",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/decathlon.png",
  //   link: 'cashkaro://stores/decathlon-coupon-excl-offr-apr26',
  //   cashback:'Upto 2.5% Cashback',
  //   bonus:'Flat ₹20 Bonus',

  // },
  {
    name: "The Man Company",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/man-company.png",
    link: 'cashkaro://stores/themancompany-coupons',
    cashback:'Flat 15% Cashback',
    // bonus:'Flat ₹20 Bonus',

  },
  {
    name: "Ajio",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/ajioo.png",
    link: 'cashkaro://stores/ajio-coupons',
    cashback:'Upto 10% Cashback',
    // bonus:'Upto ₹75 Bonus',

  },
  {
    name: "Aqualogica",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/aqualogica.png",
    link: 'cashkaro://stores/aqualogica-coupons',
    cashback:'Flat 18% Cashback',
    // bonus:'Flat ₹50 Bonus',

  },
  // {
  //   name: "Truemeds",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/netmed.png",
  //   link: 'cashkaro://stores/truemeds-coupon-code-excl-offr-apr26',
  //   cashback:'Upto ₹370 Cashback',
  //   bonus:'Flat ₹15 Bonus',

  // },
  {
    name: "Netmeds",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/netmeds.png",
    link: 'cashkaro://stores/netmeds-coupons',
    cashback:'Up to 5% Cashback',
    // bonus:'Flat ₹15 Bonus',

  },
  {
    name: "Hamara Mall",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/hamaraMall.png",
    link: 'cashkaro://stores/hamara-mall-coupons',
    cashback:'Upto 15% Cashback',
    // bonus:'Flat ₹15 Bonus',

  },

  // {
  //   name: "Realme",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/realme.png",
  //   link: 'cashkaro://stores/realme-offers-excl-offr-apr26',
  //   cashback:'Upto 2% Cashback',
  //   bonus:'Flat ₹15 Bonus',

  // },
  {
    name: "Ounce Organics",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/ounce.png",
    link: 'cashkaro://stores/ounce-organics',
    cashback:'Flat 70% Cashback',
    // bonus:'Flat ₹100 Bonus',

  },
  {
    name: "Healthkart",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/healthkart.png",
    link: 'cashkaro://stores/healthkart',
    cashback:'Flat 3% Cashback',
    // bonus:'Flat ₹15 Bonus',

  },
  {
    name: "Flipkart",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/flipkartm.png",
    link: 'cashkaro://stores/flipkart',
    cashback:'Upto 6.5% Cashback',
    // bonus:'Upto ₹75 Bonus',

  },
  {
    name: "Amazon",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/amazonm.png",
    link: 'cashkaro://stores/amazon',
    cashback:'Upto 5% Rewards',
    // bonus:'Upto ₹75 Bonus',

  },
  {
    name: "Myntra",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/myntram.png",
    link: 'cashkaro://stores/myntra',
    cashback:'Upto 6% Cashback',
    // bonus:'Upto ₹75 Bonus',

  },
  // {
  //   name: "Firstcry",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/first-cry.png",
  //   link: 'cashkaro://stores/firstcry-excl-offr-apr26',
  //   cashback:'Upto ₹35 Cashback',
  //   bonus:'Flat ₹10 Bonus',

  // },
  
];

const randomNames = [
  "Rahul",
  "Sneha",
  "Amit",
  "Priya",
  "Rohan",
  "Anjali",
  "Vikas",
  "Neha",
  "Karan",
  "Simran",
  "Arjun",
  "Pooja",
  "Diksha",
  "Abhishek",
  "Hirdesh",
  "Vridhi",
  "Suraj",
  "Aayush"
];


export default function MysteryBoxJan() {

  const [alertOpen, setAlertOpen] = useState(false);
  const [message, setMessage] = useState();
  const [transaction, setTransaction] = useState(0);
  const [Reveal, setReveal] = useState(false);
  const [registered, setRegistered] = useState(false)
  const [mbOpen, setMbOpen] = useState(localStorage.getItem('mb_open_may_new') || 0)
  const navigate = useNavigate();
  const [isPastCta1, setIsPastCta1] = useState(false)
  const cta1Ref = useRef(null);
  const [error, setError] = useState(false)
  const [daysLeft, setDaysLeft] = useState([])
  const [openModal, setOpenModal] = useState(false);
  const matches = useMediaQuery('(max-width:375px)');
  const [fabOpen, setFabOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const productsRef = useRef(null);
  const [randomUser, setRandomUser] = useState("");
const [randomAmount, setRandomAmount] = useState(0);

const generateRandomUnlock = () => {
  const name =
    randomNames[Math.floor(Math.random() * randomNames.length)];

  // Random between 50 and 499
  const amount = Math.floor(Math.random() * 450) + 50;

  setRandomUser(name);
  setRandomAmount(amount);
};
useEffect(() => {
  generateRandomUnlock();

  const interval = setInterval(() => {
    generateRandomUnlock();
  }, 10000); // change every 4 seconds

  return () => clearInterval(interval);
}, []);


  useEffect(() => {
    const ctaElement = document.getElementById('cta');
    const productsElement = document.getElementById('products');

    const observer = new IntersectionObserver(
      ([entry]) => {
        // When products element is in view
        if (entry.isIntersecting) {
          setScrolled(true)
          ctaElement.style.display = 'block'; // Hide cta
        } else {
          ctaElement.style.display = 'block'; // Show cta
        }
      },
      {
        threshold: 0.7, // Trigger when 50% of the products element is in view
      }
    );

    if (productsElement) {
      observer.observe(productsElement);
    }

    // Cleanup observer on unmount
    return () => {
      if (productsElement) {
        observer.unobserve(productsElement);
      }
    };
  }, [registered]);




  function daysUntilMarch31() {
    const today = new Date();
    const currentYear = today.getFullYear();
    const march31 = new Date(currentYear, 5, 0); // March is month 2 in JavaScript (0-indexed)

    // Check if March 31st has already passed for the current year
    if (today > march31) {
      march31.setFullYear(currentYear + 1); // Set to March 31 of the next year
    }

    // Calculate the difference in milliseconds
    const diff = march31 - today;

    // Convert milliseconds to days
    return Math.ceil(diff / (1000 * 60 * 60 * 24)) + 1
  }

  useEffect(() => {
    let days = daysUntilMarch31().toString()
    days = days.split('')
    if (days.length < 2) {

      days.unshift(0)
    }
    console.log(days)
    setDaysLeft(days)
  }, [])

  const handleFabClick = () => {
    if (!fabOpen) {
      setFabOpen(true)
    } else {
      setOpenModal(true)
    }
  }

  const scrollToProducts = () => {
    const el = document.getElementById('products');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }



  const handleImageClick = async () => {

    if (transaction > 0) {
      setReveal(true);
      localStorage.setItem('mb_open_may_new', 1)
      try {
        const params = new URLSearchParams(window.location.search);
        let ck_id = params.get('userid') || params.get('user_id') || params.get('userId') || params.get('ck_id') || params.get('ckid')
        let response = await fetch(`${process.env.REACT_APP_SITE_URL_VP}/api/user/updatedata_mb_may`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            "ck_id": `${ck_id}`,
            "claim": 1
          })

        })
        response = await response.json()
        console.log(response)
        if (response?.message) {
          navigate('/mystery-box-may-new/congrats', { replace: true });
        }
      } catch (error) {
        console.log(error.message)
      }
    }

  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    checkFunction()
  }, [])

  // Parallax scroll effect
  // useEffect(() => {
  //   const handleScroll = () => {
  //     const scrollY = window.scrollY || window.pageYOffset;

  //     setParallaxOffset(scrollY * 0.4);
  //   };

  // Initial call to set position
  // handleScroll();

  //   window.addEventListener('scroll', handleScroll, { passive: true });
  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);
  



  let checkFunction = async () => {
    let ck_id_check = localStorage.getItem('mb_ck_id_may_new')

    try {
      if (ck_id_check) {
        setRegistered(true)
        let response = await fetch(`${process.env.REACT_APP_SITE_URL_VP}/api/user/getuserdata_mb_may?ck_id=${ck_id_check}`)
        response = await response.json()
        console.log(response.user_data)
        setTransaction(response?.user_data?.transactions_tag)
        localStorage.setItem('mb_bonus_may_new', response?.user_data?.bonus)
        localStorage.setItem('mb_bonus_added_may_new', response?.user_data?.bonus_added)
        localStorage.setItem('mb_open_may_new', response?.user_data?.claim)
        if (response?.user_data?.claim == 1) {
          navigate('/mystery-box-may-new/bonus', { replace: true })
        }

      }

    } catch (error) {
      console.log(error.message)
    }
    if (mbOpen == 1) {
      navigate('/mystery-box-may-new/bonus', { replace: true })
    }
  }


  const handleButtonClick = () => {
    // Navigate to the NewPage component
    navigate('/mystery-box-may-new/congrats', { replace: true });
  };
  const showAlert = () => {
    // Just open the drawer - API call will be made inside the drawer component
    setAlertOpen(true);
  };

  const closeAlert = () => {
    setAlertOpen(false);
  };
  // if (Reveal) {
  //   return (
  //     <Grid item xs={12} sm={12} md={4} lg={4}
  //       sx={{
  //         backgroundImage: `url(${Bg})`
  //       }}>
  //       <Box sx={{
  //         position: 'relative', width: '100%',  overflow: 'hidden',
  //       }}>
  //         {/* Video Background */}
  //         <video
  //           autoPlay
  //           loop
  //           muted
  //           playsInline
  //           style={{
  //             position: 'absolute',
  //             top: 0,
  //             left: 0,
  //             width: '100%',
  //             height: '100%',
  //             objectFit: 'cover',
  //           }}
  //         >
  //           <source src="https://d2sriifpjiqv0p.cloudfront.net/Loop%20Gift.mp4" type="video/mp4" />
  //           Your browser does not support the video tag.
  //         </video>
  //         <Box
  //           sx={{
  //             backgroundImage: `url(${ctaImage})`,
  //             width: '100%',
  //             height: '100%',
  //             position: 'absolute',
  //             backgroundSize: 'cover',
  //             backgroundRepeat: 'no-repeat',
  //             backgroundPosition: 'center',
  //             top: 0,
  //             left: 0,
  //             right: 0
  //           }}
  //         >
  //           <div
  //             style={{
  //               display: 'flex',
  //               justifyContent: 'center',
  //               background: 'linear-gradient(180deg, rgba(59, 156, 190, 0) 0%, #1D4563 92.09%)',
  //               width: '100%',
  //               position: 'fixed',
  //               bottom: '0', // This fixes the element to the bottom of the screen
  //               zIndex: '9999999',
  //               // alignItems: 'center', // Uncomment if vertical alignment is needed
  //             }}
  //           >
  //             <img
  //               src={RevealButton}
  //               alt="RevealButton"
  //               style={{ width: '100%', paddingLeft: '1rem', paddingRight: '1rem' }}
  //               onClick={handleButtonClick}
  //             />
  //           </div>

  //         </Box>

  //         {/* Overlay Content */}
  //       </Box>

  //       <Box sx={{ background: '#1c4563', paddingX: '18px' }}>
  //         <Typography sx={{ textAlign: 'center', paddingTop: '16px', fontFamily: "DM Sans", marginBottom: '16px', color: '#fff', fontSize: '12px', fontWeight: 600, lineHeight: '16px', letterSpacing: '5px' }}>FAQs</Typography>
  //         {faqs.map((faq, i) => (
  //           <Box
  //             sx={{
  //               marginBottom: "16px",
  //               padding: "2px",
  //               background:
  //                 "linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);",
  //               borderRadius: "14px",
  //             }}
  //           >
  //             <Accordion
  //               sx={{
  //                 borderRadius: "14px !important",
  //                 background: "#355974",
  //                 color: "#fff",
  //                 fontSize: "14px",
  //                 fontWeight: 600,
  //                 fontFamily: 'DM Sans'
  //               }}
  //             >
  //               <AccordionSummary
  //                 expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
  //                 sx={{ color: '#FFEEC3', }}>
  //                 {faq?.question}
  //               </AccordionSummary>
  //               <AccordionDetails>{faq?.answer}</AccordionDetails>
  //             </Accordion>
  //           </Box>))}
  //       </Box>
  //       <Box sx={{ background: '#1c4563', paddingX: '18px' }} pb={16}>
  //         <Typography sx={{ textAlign: 'center', paddingTop: '16px', fontFamily: "DM Sans", marginBottom: '16px', color: '#fff', fontSize: '12px', fontWeight: 600, lineHeight: '16px', letterSpacing: '3px' }}>TERMS & CONDITIONS</Typography>
  //         {Terms.map((Terms, i) => (
  //           <Box
  //             sx={{
  //               marginBottom: "16px",
  //               padding: "2px",
  //               background:
  //                 "linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);",
  //               borderRadius: "14px",
  //             }}
  //           >
  //             <Accordion
  //               sx={{
  //                 borderRadius: "14px !important",
  //                 background: "#355974",
  //                 color: "#fff",
  //                 fontSize: "14px",
  //                 fontWeight: 600,
  //                 fontFamily: 'DM Sans'
  //               }}
  //             >
  //               <AccordionSummary
  //                 expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
  //                 sx={{ color: '#FFEEC3', }}>
  //                 {Terms?.question}
  //               </AccordionSummary>
  //               <AccordionDetails>{Terms?.answer}</AccordionDetails>
  //             </Accordion>
  //           </Box>))}
  //       </Box>
  //       {/* <Alert open={alertOpen} type="success" message={message} setOpen={setAlertOpen} /> */}
  //     </Grid>
  //   );
  // }
  return (
    <Grid container >
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
      {transaction < 1 ? (
        <Grid item xs={12} sm={12} md={4} lg={4}
          sx={{
            backgroundImage: "url(https://d2sriifpjiqv0p.cloudfront.net/mystery-box/first_bg.png)",
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundColor: '#403326',
            position: 'relative',
            overflow: 'visible',
            minHeight: '100vh',
            // backgroundPosition: 'top',
          }}>
          {/* Parallax Lottie Animation */}
          {/* <Box
            ref={parallaxRef}
            sx={{
              position: 'fixed',
              top: 0,
              left: { xs: 0, sm: 0, md: '33.33%', lg: '33.33%' },
              width: { xs: '100%', sm: '100%', md: '33.33%', lg: '33.33%' },
              height: '100vh',
              zIndex: 1,
              pointerEvents: 'none',
              transform: `translateY(${-parallaxOffset * 0.3}px)`,
              willChange: 'transform',
              overflow: 'hidden',
            }}
          >
            <Lottie
              animationData={Pallerel}
              loop
              autoplay
              style={{
                width: '100%',
                height: '120%',
                opacity: 0.9,
                position: 'absolute',
                top: 0,
                left: 0,
              }}
            />
          </Box> */}
          <Box sx={{
            position: 'relative', width: '100%', overflow: 'hidden', zIndex: 2,
          }}>
            {/* Video Background */}
            {/* <video
              autoPlay
              loop
              muted
              playsInline
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
              controls = {false}
            >
              <source src="https://d2sriifpjiqv0p.cloudfront.net/Loop%20Gift.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>  */}
            {/* <img src={staticBg} style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }} /> */}
            <Box
              id='cta'
            // sx={{
            //   backgroundImage: `url(${ctaImage})`,
            //   width: '100%',
            //   height: '100%',
            //   position: 'absolute',
            //   backgroundSize: 'cover',
            //   backgroundRepeat: 'no-repeat',
            //   backgroundPosition: 'center',
            //   top: 0,
            //   left: 0,
            //   right: 0,
            //   position: 'relative',
            // }}
            >
              <div style={{ display: 'flex', justifyContent: 'center', }}>
                <Lottie
                  animationData={MysteryLogo}
                  loop
                  autoplay
                  style={{ width: "100%", }}
                />
                {/* <img src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/Logo.png" alt="Mystery" style={{ width: window.innerWidth < 361 ? '200px' : '230px', }} /> */}
              </div>
              <div style={{ display: registered ? 'none' : 'flex', justifyContent: 'center', paddingTop: '24px' }}>
                <img src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/heading.png" alt="heading" style={{ width: window.innerWidth < 361 ? '70%' : '70%', }} />
              </div>
              <div style={{ display: registered ? 'flex' : 'none', justifyContent: 'center', paddingTop: '12px' }}>
                <img src={UnlockHeading} alt="heading" style={{ width: '80%' }} />
              </div>

              <Box sx={{
                display: 'flex',
                justifyContent: 'center',
              }}>
                <Lottie
                  animationData={MysteryBox}
                  loop
                  autoplay
                  style={{ width: "100%", }}
                />
              </Box>

              {daysLeft.length > 0 &&
                <Box sx={{ display: 'flex', justifyContent: 'center' }} mt={3}>
                  <Typography sx={{ position: 'relative', zIndex: 1, color: '#fff', fontWeight: '500', lineHeight: '100%', fontSize: '13.93px', fontFamily: "Metropolis", }}>
                    Offer ending in <br /><span style={{ padding: '2px 7px', borderRadius: '4px', fontFamily: 'Averia Serif Libre', color: '#F9C98C', fontWeight: '700', fontSize: '25px', lineHeight: '100%' }}>{daysLeft} Days </span>
                  </Typography>

                </Box>
              }

              {/* {!registered ? '' : transaction > 0 ? '' :     <Box sx={{ paddingTop: '12px', position: 'absolute', left: '38%', bottom: '-20px',zIndex:99999999999999 }}>
             <img src={Scroll} style={{height:'80px'}} />
            
              </Box>} */}
              <div ref={cta1Ref} style={{ marginTop: '2rem' }}>
                <div style={{ display: 'flex', justifyContent: 'center' }}>

                  {!registered ? (
                   <Box
                   sx={{
                     display: "flex",
                     flexDirection: "column",
                     width: "100%",
                   }}
                 >
                   <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                     <Lottie
                       animationData={RegisterButtons}
                       loop
                       autoplay
                       style={{ width: "100%" }}
                       onClick={showAlert}
                     />
                   </Box>
                 
                   <Box
                    //  mt={1}
                     sx={{
                       background: "linear-gradient(90deg, #403326 0%, #6C5743 50%, #403326 100%)",
                       border: "1px solid",
                       borderImageSource:
                         "linear-gradient(90deg, #403326 0%, #90705B 50%, #403326 100%)",
                       borderImageSlice: 1,
                       width: "100%",
                     }} mb={4}
                   >
                     <Typography
                       sx={{
                         textAlign: "center",
                         color: "#EDD0B9",
                         fontWeight: 700,
                         fontSize: "12px",
                         fontFamily: "metropolis",
                       }}
                     >
                       <span style={{ fontWeight: 800 }}>{randomUser}</span> just unlocked{" "}
                       <span style={{ color: "#F9C98C", fontWeight: 900 }}>
                         ₹{randomAmount}
                       </span>{" "}
                       Bonus Cashback
                     </Typography>
                   </Box>
                 </Box>
                    

                    
                    








                    // <img
                    //   src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/Button.png"
                    //   alt="RegisterButton"
                    //   style={{ width: '80%', visibility: error ? 'hidden' : 'visible' }}
                    //   onClick={showAlert}
                    // />
                  ) : transaction > 0 ? (<img
                    src={RevealButton}
                    alt="RevealButton"
                    style={{ width: '100%', paddingLeft: '1rem', paddingRight: '1rem' }}
                    onClick={handleButtonClick}
                  />) : (

                    scrolled ? <img
                      onClick={() => setOpenModal(true)}
                      src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/unlockButton.png"
                      alt="Unlock"
                      style={{ width: '80%', visibility: openModal ? 'hidden' : 'visible', zIndex: '999999999999999' }}

                    // onClick={showAlert}
                    /> :

                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', gap: '8px', marginBottom: '10px' }}>
                        {/* <Box onClick={scrollToProducts}>
                          <img src={Scroll} style={{ height: '47px', width: '40px', border: '1px solid #F3EAF7', borderRadius: '12px', marginBottom: '8px' }} />
                        </Box> */}
                        <img
                          onClick={() => setOpenModal(true)}
                          src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/unlockButton.png"
                          alt="Unlock"
                          style={{ width: '80%', visibility: openModal ? 'hidden' : 'visible' }}

                        // onClick={showAlert}
                        />
                      </Box>

                  )}
                </div>

                <Dialog
  open={openModal}
  onClose={() => setOpenModal(false)}
  fullScreen
  PaperProps={{
    sx: {
      margin: 0,
      borderRadius: 0,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      position: "relative",
      overflow: "hidden",
    }
  }}
  BackdropProps={{
    sx: {
      backdropFilter: "blur(6px)",
      backgroundColor: "rgba(0,0,0,0.3)",
    },
  }}
>
  <Box
    sx={{
      width: "100%",
      height: "100vh",   // 🔥 Correct full device height
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background:'#7e6852'
    }}
  >
   <Box
  onClick={() => {
    setOpenModal(false);

    // Delay to allow dialog close animation
    setTimeout(() => {
      const el = document.getElementById("trending-deals");
      if (el) {
        const yOffset = -20; // adjust if you add sticky header
        const y =
          el.getBoundingClientRect().top +
          window.pageYOffset +
          yOffset;

        window.scrollTo({
          top: y,
          behavior: "smooth",
        });
      }
    }, 300);
  }}
  sx={{ width: "100%", height: "100%", cursor: "pointer" }}
>
  <Lottie
    animationData={Remember}
    loop
    autoplay
    style={{
      width: "100%",
      height: "100%",
    }}
  />
</Box>
  </Box>


  
</Dialog>
              </div>



            </Box>

            {/* Overlay Content */}
          </Box>

          {/* {registered ? <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
            <img src={dor} style={{ height: '121px', width: '328px' }} />
          </Box> : ''} */}
          {
            !registered ? '' : transaction > 0 ? '' : <Box>
              {/* {/* <Box sx={{ backgroundColor: '#308bb5', }}>
                <img src={subtract} style={{ width: '100%', position: 'absolute', marginTop: '-170px' }} /> */}



              {/* </Box>  */}
              <Box
                ref={productsRef}
                id='products' sx={{
                  marginTop: '-10px', background: "radial-gradient(50% 50% at 50% 50%, #191109 0%, #403326 100%)"
                }}>
                <Box
                  sx={{
                    background: "linear-gradient(90deg, #403326 0%, #6C5743 50%, #403326 100%)",
                    border: "1px solid",
                    borderImageSource:
                      "linear-gradient(90deg, #403326 0%, #90705B 50%, #403326 100%)",
                    borderImageSlice: 1,
                  }} mt={1}
                >
<Typography
  sx={{
    textAlign: "center",
    color: "#EDD0B9",
    fontWeight: 700,
    fontSize: "12px",
    fontFamily: "metropolis",
  }}
>
  <span style={{ fontWeight: 800 }}>{randomUser}</span> just unlocked{" "}
  <span style={{ color: "#F9C98C", fontWeight: 900 }}>
    ₹{randomAmount}
  </span>{" "}
  Bonus Cashback
</Typography>                </Box>


                <Box
                  sx={{
                    background: "linear-gradient(111.27deg, #F6CFB0 25.31%, #FFFFFF 74.69%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    // lineHeight:'76%',
                    fontFamily: "Averia Serif Libre",
                    fontWeight: 700,
                    fontSize: "35px",
                    textAlign: "center",
                  }} mt={3} 
                  id="trending-deals"
                >
                  Trending Deals
                </Box>
                <Box
                  sx={{
                    color: '#fff',
                    fontFamily: "metropolis",
                    fontWeight: 500,
                    fontSize: "14px",
                    textAlign: "center",
                  }}
                >
                  Explore top deals of the day
                </Box>
                {/* <Box px={3.75} pt={3}>
                  <img src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/banner.png" alt='banner' style={{ width: '100%' }} />
                </Box> */}

                <Grid container px={2} mt={3}>
                  <Grid item xs={6} sm={6}>
                    <a href='cashkaro://top-selling-products/flash-deals'>
                    <Box
                      component="img"
                      src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/flashDeal.png"
                      alt="banner"
                      sx={{ width: '100%', }}
                    />
                    </a>
                  </Grid>

                  <Grid item xs={6} sm={6}>
                    <Box
                      component="img"
                      src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/cashback.png"
                      alt="banner"
                      sx={{ width: '100%', }}
                      onClick={() => {
                        const el = document.getElementById("bonus-cb");
                        if (el) {
                          const yOffset = -20; // adjust if needed
                          const y =
                            el.getBoundingClientRect().top +
                            window.pageYOffset +
                            yOffset;
                  
                          window.scrollTo({
                            top: y,
                            behavior: "smooth",
                          });
                        }
                      }}
                    />
                  </Grid>
                </Grid>
                <a href='cashkaro://home'>
                <Box
                  component="img"
                  src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/HOMEPAGE.png"
                  alt="banner"
                  sx={{ width: '100%', }} px={3} pt={1}
                />
                </a>
                <Grid container px={2}>
                  <Grid item xs={6} sm={6}>
                  <a href="cashkaro://products/home-categories-exclusive/fashion-offers">
                    <Box
                      component="img"
                      src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/fashionCat.png"
                      alt="banner"
                      sx={{ width: '100%', }}
                    />
                    </a>
                  </Grid>

                  <Grid item xs={6} sm={6}>
                  <a href="cashkaro://products/home-categories-exclusive/beauty-personal-care-offers">
                    <Box
                      component="img"
                      src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/fourth.png"
                      alt="banner"
                      sx={{ width: '100%', }}
                    />
                    </a>
                  </Grid>
                </Grid>

                <Box id='bonus-cb'
                  sx={{
                    background: "linear-gradient(111.27deg, #F6CFB0 25.31%, #FFFFFF 74.69%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    lineHeight: '100%',
                    fontFamily: "Averia Serif Libre",
                    fontWeight: 700,
                    fontSize: "35px",
                    textAlign: "center",
                  }} mt={3}
                >
                  Earn More <br />Cashback
                </Box>
                <Box>
                  <Grid container spacing={2} justifyContent="center" px={2} pt={5} mb={4}>
                    {deals.map((item, index) => (
                      <Grid item xs={4} sm={4} md={4} key={index}>
                        <Box
                          sx={{
                            textAlign: "center",
                            color: "#E6D8C9",
                          }}
                        >
                          {/* Logo */}
                          <Box
                            component="img"
                            src={item.img}
                            alt={item.name}
                            sx={{
                              width: "100%",
                              objectFit: "contain",
                              mx: "auto",
                            }}
                          />

                          {/* Brand Name */}
                          <Typography
                            sx={{
                              fontSize: { xs: "10px" },
                              fontWeight: 600,
                              background: "linear-gradient(90deg, #B9A593 0%, #93785F 100%)",
                              WebkitBackgroundClip: "text",
                              WebkitTextFillColor: "transparent",
                              fontFamily: 'metropolis'
                            }}
                          >
                            {item.name}
                          </Typography>

                          {/* Cashback Text */}
                          <Typography
                            sx={{
                              mt: 1,
                              fontSize: "10px",
                              fontWeight: 600,
                              background: "linear-gradient(90deg, #F8DBC4 0%, #FFFFFF 100%)",
                              WebkitBackgroundClip: "text",
                              WebkitTextFillColor: "transparent",
                              fontFamily: 'metropolis'

                            }}
                          >
                            {item.cashback}
                          </Typography>

                          {/* <Typography
                            sx={{
                              fontSize: "11px",
                              fontWeight: 600,
                              background: "linear-gradient(90deg, #F8DBC4 0%, #FFFFFF 100%)",
                              WebkitBackgroundClip: "text",
                              WebkitTextFillColor: "transparent",
                              fontFamily: 'metropolis'
                            }}
                          >
                            + {item.bonus}
                          </Typography> */}

                          {/* Button */}
                          <a
                            href={item.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: "inline-block",
                              textDecoration: "none",
                            }}
                          >
                            <img
                              src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/shopNow.png"
                              alt="Shop Now"
                              style={{
                                width: "100%",
                                maxWidth: "180px",
                                display: "block",
                                marginTop: "10px",
                                cursor: "pointer",

                              }}
                            />
                          </a>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Box>



              </Box>
              {/* <Box sx={{ position: 'relative', marginTop: '20px' }}>
                <img src={newsec24} alt="test" style={{ width: '100%', display: 'block', zIndex: 1, position: 'relative' }} />
                <Box
                  component="a"
                  href="cashkaro://top-selling-products/best-finance-deals"
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '50%',
                    height: '100%',
                    cursor: 'pointer',
                    zIndex: 2,
                    // backgroundColor: 'rgba(255, 0, 0, 0.3)'
                  }}
                />
                <Box
                  component="a"
                  href={`cashkaro://page/sale-exclusive-offer?userId=${localStorage.getItem('mb_ck_id_jan')}`}
                  sx={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: '50%',
                    height: '100%',
                    cursor: 'pointer',
                    zIndex: 2,
                    // backgroundColor: 'rgba(0, 0, 255, 0.3)'
                  }}
                />
              </Box> */}


              {/* <Box sx={{ width: '100%' }}>
                <a href='cashkaro://home'><img src={Explore} style={{ width: '100%' }} /></a>
              </Box> */}
            </Box>
          }

<Box >
<Faq/>
</Box>
          
          <RegisterDrawer
            open={alertOpen}
            setOpen={setAlertOpen}
            setError={setError}
            setRegistered={setRegistered}
            checkFunction={checkFunction}
            onRedirect={() => {
              // Add your redirect logic here if needed
              // For example: navigate('/some-path');
            }}
          />
          <ErrorAlert open={error} type="error" message={'You are not eligible for this campaign!'} setOpen={setError} />

        </Grid>
      ) : (




        // Else, show a thank you message (or any other content you want)
        <Grid item xs={12} sm={12} md={4} lg={4}
          sx={{
            backgroundImage: "url(https://d2sriifpjiqv0p.cloudfront.net/mystery-box/first_bg.png)", backgroundSize: 'contain'
          }}>
          <Box sx={{
            position: 'relative', width: '100%', overflow: 'hidden',
          }}>
            {/* Video Background */}
            {/* <video
              autoPlay
              loop
              muted
              playsInline
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            >
              <source src="https://d2sriifpjiqv0p.cloudfront.net/Loop%20Gift.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video> */}
            {/* <img src={staticBg} style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }} /> */}
            <Box
              sx={{
                // backgroundImage: `url(${ctaImage})`,
                // width: '100%',
                // height: '100%',
                // position: 'absolute',
                // backgroundSize: 'cover',
                // backgroundRepeat: 'no-repeat',
                // backgroundPosition: 'center',
                // top: 0,
                // left: 0,
                // right: 0
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'center', }}>
                <Lottie
                  animationData={MysteryLogo}
                  loop
                  autoplay
                  style={{ width: "100%", }}
                />
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '12px', alignItems:'center' }}>
                {/* <img src={Mbheading} alt="heading" style={{ width: '100%' }} /> */}
                {/* <Typography sx={{ fontSize: '16.79px', fontWeight: '600', color: '#fff', lineHeight: '100%', fontFamily: 'metropolis', textAlign: 'center' }}>CLAIM UPTO</Typography> */}
                <img src='https://d2sriifpjiqv0p.cloudfront.net/mystery-box/offer.png' alt='offer' style={{width:'80%'}}/>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '12px',}}>
                <div> 
                <Lottie
                  animationData={MysteryBox}
                  loop
                  autoplay
                  style={{ width: "100%", }}
                />
                </div>
              </div>
              {daysLeft.length > 0 &&
                <Box sx={{ display: 'flex', justifyContent: 'center' }} mt={3} mb={2}>
                  <Typography sx={{ position: 'relative', zIndex: 1, color: '#fff', fontWeight: '500', lineHeight: '100%', fontSize: '13.93px', fontFamily: "Metropolis", }}>
                  <span style={{ padding: '2px 7px', borderRadius: '4px', fontFamily: 'Averia Serif Libre', color: '#F9C98C', fontWeight: '700', fontSize: '25px', lineHeight: '100%' }}>{daysLeft} DAYS LEFT</span>
                  </Typography>

                </Box>
              }
              {/* {daysLeft.length > 0 && <Box sx={{ display: 'flex', justifyContent: 'center', paddingTop: '12px', }}>
                <Typography sx={{ position: 'relative', zIndex: 1, color: '#F9C98C', fontWeight: '700', fontSize: '24px', fontFamily: "Averia Serif Libre", textAlign: 'center' }}>
                  {daysLeft[1]} DAYS LEFT
                </Typography>
              </Box>} */}
              <div ref={cta1Ref} style={{
                display: 'flex',
                justifyContent: 'center',
                bottom: '0',
                // background: 'linear-gradient(180deg, rgba(59, 156, 190, 0) 0%, #1D4563 92.09%)',
                width: '100%',
                // position: 'fixed',
                zIndex: '9999999',
                // alignItems: 'center', // Ensures vertical alignment if needed
              }}>
                {Reveal ? (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      // background: 'linear-gradient(180deg, rgba(59, 156, 190, 0) 0%, #1D4563 92.09%)',
                      width: '100%',
                      // position: 'fixed',
                      // bottom: '0', // This fixes the element to the bottom of the screen
                      zIndex: '9999999',
                      // alignItems: 'center', // Uncomment if vertical alignment is needed
                    }}
                  >
                    <img
                      src={RevealButton}
                      alt="RevealButton"
                      style={{ width: '100%', paddingLeft: '1rem', paddingRight: '1rem' }}
                      onClick={handleButtonClick}
                    />
                  </div>
                ) : (
                  <img
                    src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/openBox.png"
                    alt="Openimage"
                    style={{ width: '80%' }}
                    onClick={handleImageClick}
                  />
                )}
              </div>
            </Box>

            {/* Overlay Content */}
          </Box>

{/* //test */}
<Box>
<Faq/>
</Box>
         












         
          {/* <Alert open={alertOpen} type="success" message={message} setOpen={setAlertOpen} /> */}
        </Grid>
      )}
      {/* {registered ?       <Fab onClick={handleFabClick} variant='extended' sx={{
        bottom: '20%', right: 0, position: 'fixed', borderRadius: '16px 0px 0px 16px', background: '#123753', border: '1px solid #fff', borderRight: 'none', height: '42px', '&:hover': {
          backgroundColor: '#123753',  // or keep your background color here '#123753'
        }
      }}>
        <Box sx={{ display: 'flex', gap: '16px' }}>
          <img src={Message} alt='yesyus' style={{ height: '24px' }} />
          {fabOpen ? <Typography sx={{
            fontFamily: "DM Sans",
            fontWeight: 800,
            fontSize: "14px",
            lineHeight: "170%",
            letterSpacing: "0%",
            textAlign: "center",
            verticalAlign: "bottom",
            textTransform: "capitalize", color: '#fff'
          }}>Steps to Unlock</Typography> : ''}

        </Box>
      </Fab> : ''} */}
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>

    </Grid>
  );
}
